import ABCyaPhaser from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import DrawLightsInstructions from './DrawLightsInstructions';
import GameTitleText from '../gameobjects/GameTitleText';

export default class MathResults extends Phaser.Scene
{
    static get KEY() { return 'MathResults'; }

    constructor()
    {
        super({ key: (MathResults).KEY });
    }

    create()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._correct, this);

        const { gameConfig } = ABCyaLib.Environment.instance;
        
        const bg = this.add.rectangle(0,0, this.scale.width, this.scale.height, 0x0f75bc).setOrigin(0);

        const title = new GameTitleText(this, this.scale.width / 2, 150, 0.75, 60);

        const resultsHeadingText = ABCyaPhaser.Text.addText(this.scale.width/2, 305, 38, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.results_screen.results_header"), this, true).setOrigin(0.5);
        const lightsHeadingText = ABCyaPhaser.Text.addText(this.scale.width/2, 424, 38, 0xffffff, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.results_screen.lights_header"), this, true).setOrigin(0.5);

        let numCorrect = gameData.correctAnswers;
        let numWrong = gameData.wrongAnswers;

        let lightsPerCorrectAnswer = 3 * gameData.difficulty;

        let line1 = ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.results_screen.information").replace("~", numCorrect).replace("~", numWrong);
        ABCyaPhaser.Text.addText(this.scale.width / 2, this.scale.height / 2 - 30, 36, 0xeeeeee, FontKeys._odin_roundedregular, line1, this, true);

        let lightString = lightsPerCorrectAnswer * numCorrect === 1 ? ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.results_screen.light") : ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.results_screen.lights");

        let line2 = numCorrect + " " + ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.results_screen.correct") + " \u00d7 " + lightsPerCorrectAnswer + " = " + (lightsPerCorrectAnswer * numCorrect) + " " + lightString;
        
        ABCyaPhaser.Text.addText(this.scale.width / 2+gameConfig.mathResultsLinePosition, this.scale.height / 2 + 90, 36, 0xeeeeee, FontKeys._odin_roundedregular, line2, this).setOrigin(1, 0.5);

        lightString = numWrong === 1 ? ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.results_screen.light") : ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.results_screen.lights");

        let line3 = numWrong + " " + ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.results_screen.incorrect") + " = -" + numWrong + " " + lightString;
        ABCyaPhaser.Text.addText(this.scale.width / 2+gameConfig.mathResultsLinePosition, this.scale.height / 2 + 130, 36, 0xeeeeee, FontKeys._odin_roundedregular, line3, this).setOrigin(1, 0.5);

        let lightsEarned = ((lightsPerCorrectAnswer * numCorrect) - numWrong);
        if (lightsEarned < 0)
        {
            lightsEarned = 0;
        }

        lightString = lightsEarned === 1 ? ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.results_screen.light") : ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.results_screen.lights");

        let line4 = ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.results_screen.total") + " = " + lightsEarned + " " + lightString;
        ABCyaPhaser.Text.addText(this.scale.width / 2+gameConfig.mathResultsLinePosition, this.scale.height / 2 + 170, 36, 0xeeeeee, FontKeys._odin_roundedregular, line4, this).setOrigin(1, 0.5);

        gameData.lightsEarned = lightsEarned;

        this.nextButton = ABCyaPhaser.Buttons.addSimpleButton(this.scale.width / 2 + 430, this.scale.height - 75, UIAssetKeys._sprites_go_button, null, () =>
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
            this.scene.start(DrawLightsInstructions.KEY);
        }, this).setScale(0.6);

        this.tweens.timeline(
            {
                tweens:
                    [
                        ABCyaPhaser.Tweens.createTween(this.nextButton, 500, { scale: 1, offset: 100 }, Phaser.Math.Easing.Quadratic.Out),
                        ABCyaPhaser.Tweens.createTween(this.nextButton, 200, { scale: 0.6, offset: 600 }, Phaser.Math.Easing.Quadratic.Out),
                    ],
            }
        );
    }
}